import React from 'react'
import './Home.css'
import { FaBath } from "react-icons/fa";
import { FaArrowRight } from "react-icons/fa";
import { FaScrewdriverWrench } from "react-icons/fa6";
import { GiKitchenTap } from "react-icons/gi";
import { Link } from 'react-router-dom';
import img1 from './image/image-1.png'
import img2 from './image/image-2.png'
import img3 from './image/image-3.png'
import Aboutus from './Aboutus';
import ProductList from './ProductList';

export default function Home() {
  return (
    <div className='home'>
     <ProductList/>
    

<div className='aboutus'>
  <Aboutus/>
</div>

</div>

    
  )
}
